<template>
  <div class="page_content">

    <div class="watermark_div" v-if="userinfo.watermark_txt">
      <Watermark :content="userinfo.watermark_txt" :rotate="-30" :z-index="1000"
        :textStyle="userinfo.watermark_text_style"></Watermark>
    </div>
    <div class="left1">

      <div class="sys_btn_cut" @click="click_cut_sys">
        <span class="sys_btn_cut_title" v-if="cut_sys_id == 'hro'">HRO系统</span>
        <span class="sys_btn_cut_title" v-if="cut_sys_id == 'jiaoyu'">教育系统</span>
        <span class="sys_btn_cut_title" v-if="cut_sys_id == 'liepin'">猎聘系统</span>
        <div class="sys_cut">
          <Icon type="md-repeat" />
          <span class="cut_sys_span">切换</span>
        </div>

      </div>
      <div class="userinfo_avatar_div">
        <div>
          <img v-if="userinfo.avatar" class="user_avatar" :src="userinfo.avatar" alt="头像" />
          <div v-else class="user_avatar" :src="userinfo.avatar" alt="头像"></div>
        </div>

        <div class="username">
          {{ userinfo.name }}
        </div>
      </div>

      <div>
        <div @click="click_menu(item)" v-for="(item, i) in menu_list" :key="i"
          :class="menu_select == item.key ? 'menu_btn' : 'menu_btn2'">
          <span :class="'iconfont ' + item.icon"></span>

          <span class="menu_btn_span">{{ item.name }}</span>

          <div class="msg_count" v-if="item.key == 'message' && msg_count > 0">
            {{ msg_count }}
          </div>
          <div class="msg_count" v-if="item.key == 'study' && study_count > 0">
            {{ study_count }}
          </div>
        </div>
      </div>

      <div class="resetmenu">
        <div @click="click_menu(item)" v-for="(item, i) in rest_menu_list" :key="i"
          :class="menu_select == item.key ? 'menu_btn' : 'menu_btn2'">
          <span :class="'iconfont ' + item.icon"></span>

          <span class="menu_btn_span">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <div>
      <!-- 消息列表 -->
      <message_list :class="menu_select == 'message' ? '' : 'dispno'" ref="message_list" @change="message_change">
      </message_list>



      <!-- 学习中心 -->
      <study :class="menu_select == 'study' ? '' : 'dispno'" ref="study"></study>

      <!-- 使用帮助 -->
      <help :class="menu_select == 'help' ? '' : 'dispno'" ref="help"></help>

      <!-- 个人信息 -->

      <app_user_info ref="app_user_info" :class="menu_select == 'uinfo' ? '' : 'dispno'">
      </app_user_info>

      <!-- 安全中心 -->

      <user_safe :class="menu_select == 'safe' ? '' : 'dispno'" ref="user_safe"></user_safe>

      <!-- 下载相关 -->

      <app_download :class="menu_select == 'download' ? '' : 'dispno'" ref="app_download"></app_download>

      <!-- 系统设置 -->

      <system_setting :class="menu_select == 'system_setting' ? '' : 'dispno'" @change="system_setting_change"
        ref="system_setting"></system_setting>

      <!-- 工作台 -->
      <workbench :class="menu_select == 'workbench' ? '' : 'dispno'" ref="workbench" @change="workbench_change">
      </workbench>

      <!-- 工具包 -->
      <tools :class="menu_select == 'tools' ? '' : 'dispno'" ref="tools"></tools>

      <!-- <Tabs style="margin-left:10px;" v-if="menu_select == 'workbench'">
        <TabPane label="HRO系统" :disabled="sys_type_list.indexOf('hro') == -1">
          <div class="tabs1_class">

          </div>
        </TabPane>
        <TabPane label="考证系统" :disabled="sys_type_list.indexOf('jiaoyu') == -1">标签二的内容</TabPane>
        <TabPane label="猎聘系统" :disabled="sys_type_list.indexOf('liepin') == -1">标签三的内容</TabPane>
      </Tabs> -->
    </div>

    <audio id="notify_mp3_url" controls v-if="notify_mp3_show">
      <source :src="notify_mp3_url" type="audio/mpeg" />
    </audio>


    <Modal v-model="cut_sys_show" title="切换系统" @on-ok='cut_sys_ok' width="240">
      <Select clearable v-model="cut_sys_id" style="width: 200px">
        <Option value="hro">HRO系统</Option>
        <Option value="jiaoyu">教育系统</Option>
        <Option value="liepin">猎聘系统</Option>
      </Select>
    </Modal>

    <Modal v-model="cut_sys_default_show" title="选择系统" width="450" :footer-hide="true" :closable="false"
      :mask-closable="false">
      <div class="sys_cut_btn_div">
        <div v-for="(item, i) in sys_type_list" :key="i" @click="cut_sys_default_ok(item)">
          <div v-if="item == 'hro'" class="sys_cut_btn">
            <Icon type="md-cube" color="#0466dd" style="margin-right:10px" />HRO系统
          </div>
          <div v-if="item == 'jiaoyu'" class="sys_cut_btn">
            <Icon type="md-cube" color="#0466dd" style="margin-right:10px" />教育系统
          </div>
          <div v-if="item == 'liepin'" class="sys_cut_btn">
            <Icon type="md-cube" color="#0466dd" style="margin-right:10px" />猎聘系统
          </div>
        </div>
      </div>
    </Modal>


    <Modal v-model="study_show" title="学习中心小提示" ok-text="🤩去看看" cancel-text="少管我，我就不学" @on-ok='study_ok'>
      <div>
        您当前有<span style="font-weight: 600;padding:0 3px;color: blue;">{{ study_count }}</span>个新技能未学习，急需学习，快去【学习中心】看看吧
      </div>
    </Modal>

    <Modal v-model="zongjie_show" title="提示" ok-text="🤩去看看" cancel-text="不需要" @on-ok='zongjie_ok'>
      <div>
        AI按您全年提交的钉钉日志，自动生成您的2025年全年总结，帮助您更好的总结，已经帮助小伙伴累计生成了 <span style="font-weight: 600;font-size:16px;">
          {{ zontjie_total_count }}份</span>，用了都说好。是否要去看看？
      </div>
    </Modal>

    <Modal v-model="zongjie_detail_show" title="AI总结中" :mask-closable="false" width="80">
      <div class="zongjie_div">
        <div>
          <Alert type="success">年度总结按本人全年钉钉日志AI智能总结生成，由于生成较久，生成后建议复制保存。</Alert>
        </div>
        <Spin fix v-if="zongjie_loading">日志总结中，为了您更好的写PPT，请等待这关键的2分钟..</Spin>
        <div class="text-container">
          <!-- <div v-html="zongjie_detail_txt" class="markdown-content"></div> -->
          <markdown-viewer :content="zongjie_detail_txt" />

          <!-- {{ zongjie_detail_txt }} -->

        </div>
      </div>

    </Modal>


    <!-- 通知 -->

    <!-- <Modal
    
          width="60%"
    
          @on-visible-change="sys_notify_change"
    
          v-model="sys_notify_show"
    
          title="系统通知"
    
          :footer-hide="true"
    
        >
    
          <div class="tongzhi">
    
            <div v-if="tonzhi_list">
    
              <div v-for="(item, i) in tonzhi_list" :key="i">
    
                <Alert :type="item.notify_type">
    
                  <div class="tongzhi_title">
    
                    【{{ item.notify_year }}年第{{ item.notify_num }}号通知】 {{ item.title }}
    
                  </div>
    
    
    
                  <template #desc>
    
                    <div v-html="item.detail" class="tongzhi_detail"></div>
    
                    <div class="tongzhi_time">{{ item.create_time }}</div>
</template>
</Alert>
</div>
</div>
<div v-else>暂无通知</div>
</div>
<div class="btn_div">
  <Button type="primary" @click="sys_notify_show = false">我知道了</Button>
</div>
</Modal> -->
  </div>
</template>

<script>
import message_list from "@/views/user/message/index.vue";
import study from '@/views/user/study/study_index.vue'
import user_safe from "@/views/user/safe/safe.vue";
import app_download from "@/views/user/app_download/index.vue";
import system_setting from "@/views/user/system_setting/index.vue";
import app_user_info from "@/views/user/info/index.vue";
import workbench from "@/views/user/workbench/index.vue";
import help from "@/views/user/help/index.vue";
import tools from '@/views/user/tools/index.vue'
import { open_new_page, http, get_browser_id } from "@/utils/http";
import Watermark from '@/component/watermark/watermark.vue'

// 引入push
//import Push from "push.js";

export default {
  components: {
    message_list,
    user_safe,
    app_download,
    system_setting,
    workbench,
    app_user_info,
    help,
    study,
    tools,
    Watermark
  },
  data() {
    return {
      menu_select: "message",
      menu_list: [
        {
          name: "消息",
          key: "message",
          icon: "iconxiaoxi1",
          path: "/user/index/v2",
          type: "button",
        },
        {
          name: "工作台",
          key: "workbench",
          icon: "icongongzuotai2",
          path: "/user/index/v2",
          type: "button",
        },
        // {
        //   name: "学习中心",
        //   key: "study",
        //   icon: "iconxuexizhongxin",
        //   path: "/user/index/v2",
        //   type: "button",
        // },
        {
          name: "使用帮助",
          key: "help",
          icon: "iconbangzhu",
          path: "/user/index/v2",
          type: "button",
        },
        {
          name: "常用工具",
          key: "tools",
          icon: "icongongju-",
          path: "/user/index/v2",
          type: "button",
        },
      ],

      rest_menu_list: [
        {
          name: "个人信息",
          key: "uinfo",
          icon: "icongerenzhongxin",
          path: "/user/info",
          type: "button",
        },
        {
          name: "安全中心",
          key: "safe",
          icon: "iconaq",
          path: "/user/safe",
          type: "button",
        },
        {
          name: "APP下载",
          key: "download",
          icon: "iconxz",
          path: "/user/index/v2",
          type: "button",
        },
        // {
        //   name: "系统设置",
        //   key: "system_setting",
        //   icon: "iconshezhi",
        //   path: "/user/index/v2",
        //   type: "button",
        // },
        {
          name: "退出登录",
          key: "quit_system",
          icon: "icontuichu",
          path: "#",
          type: "quit",
        },
      ],

      userinfo: {
        name: "",
        avatar: "",
      },
      notify_mp3_url: "",
      notify_mp3_show: false,

      msg_count: 0,
      // 消息定时器
      msg_count_timer: null,
      msg_notify_end_tsp: 0,
      msg_notify_end_count: 0,

      //通知
      tonzhi_list: [],
      // cookie作用域
      cookie_domain: "",
      // 浏览器通知频率按秒
      browser_notify_frequency: 5,

      study_count: 0,
      study_show: false,
      zongjie_show: false,
      zongjie_detail_show: false,
      zongjie_loading: false,
      zongjie_detail_txt: '# 工作总结',
      zontjie_total_count: 0,
      sys_type_list: [],

      cut_sys_show: false,
      cut_sys_id: '',

      cut_sys_default_show: false
    };
  },

  created() {
    if (window.location.hostname == "localhost") {
      this.cookie_domain = "localhost";
    } else {
      this.cookie_domain = process.env.VUE_APP_COOKIES_DOMAIN;
    }
    // 获取通知权限
    // Push.Permission.request();
    // 消息小红点定时器
    this.get_msg_count();

  },

  mounted() {
    this.cut_sys_id = this.$cookies.get("dx_cut_sys_id"),

      //页面变化监听
      this.page_change_monitor();
    // 获取用户信息
    this.get_user_info();
    // 获取通知音乐
    this.get_mp3_notify();
    // 获取消息列表数据
    this.$refs.message_list.open();
    this.get_study_count();
    this.year_end_summary_count();
    this.get_user_sys_list();



    //
    // window.addEventListener("beforeunload", this.showUnloadMessage);
  },

  beforeDestroy() {
    // window.removeEventListener("beforeunload", this.showUnloadMessage);
    // 在组件销毁前清除定时器
    clearInterval(this.msg_count_timer);
  },

  methods: {

    cut_sys_ok() {
      var that = this
      console.log(this.cut_sys_id)

      that.$cookies.set(
        "dx_cut_sys_id",
        that.cut_sys_id,
        3600 * 24 * 7,
        "/",
        that.cookie_domain
      );
      this.$refs.workbench.open();

    },

    cut_sys_default_ok(cut_sys_id) {
      var that = this
      that.$cookies.set(
        "dx_cut_sys_id",
        cut_sys_id,
        3600 * 24 * 7,
        "/",
        that.cookie_domain
      );
      this.cut_sys_default_show = false
      this.cut_sys_id = cut_sys_id
      this.$refs.workbench.open();

    },
    click_cut_sys() {
      this.cut_sys_show = true
    },

    year_end_summary_count() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/notify/year_end_summary_count",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {

            that.zontjie_total_count = res.data.total_count
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }

        })
        .catch((res) => {

        });
    },

    zongjie_ok() {
      var that = this;
      var obj = {};
      this.zongjie_loading = true
      this.zongjie_detail_show = true
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/notify/year_end_summary",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {

            that.zongjie_detail_txt = res.data.content
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.zongjie_loading = false

        })
        .catch((res) => {

        });
    },
    //推送弹框消息
    pushMessage(title, body, func) {
      if (title == null || title == undefined) {
        title = "新消息";
      }
      if (body == null || body == undefined) {
        body = "";
      }
      // Push.create(title, {
      //   body: body,
      //   requireInteraction: true,
      //   icon: "/src/assets/image/user/logo_38.png",
      //   vibrate: [200, 100, 200, 100, 200, 100, 400],
      //   timeout: 5000,
      //   onClick: () => {
      //     if (func) {
      //       func();
      //     }
      //   },
      // });
    },

    study_ok() {
      this.click_menu(this.menu_list[2])
    },

    //获取未学习数量
    get_study_count() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/study_count",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.study_count = res.data.study_count
            if (that.study_count > 0) {
              that.study_show = true
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },


    get_user_sys_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/user_sys_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.sys_type_list = res.data.sys_type_list;
            var dx_cut_sys_id = that.$cookies.get("dx_cut_sys_id")
            console.log(dx_cut_sys_id)
            if (dx_cut_sys_id) {

            } else {
              that.cut_sys_default_show = true
            }
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_user_info() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/user_index/v2/nav_user_info",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.userinfo = res.data.user_info;
            that.browser_notify_frequency = res.data.user_info.browser_notify_frequency;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    // 页面变化监听
    page_change_monitor() {
      var _menu_list = this.rest_menu_list.concat(this.menu_list);
      var query = this.$route.query;
      if (query.page == undefined) {
      } else {
        for (var i = 0; i < _menu_list.length; i++) {
          if (query.page == _menu_list[i]["key"]) {
            this.click_menu(_menu_list[i]);
          }
        }
      }
    },

    //获取通知音乐
    get_mp3_notify() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/message/notify_mp3",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.notify_mp3_url = res.data.mp3_url;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    //消息组件变化
    message_change(e) {
      if (e == "play_notify_mp3") {
        console.log("组件要播放");
        // this.msg_notify();
        this.show_message_notify()
      }
    },

    workbench_change(e) {
      console.log(e);
      if (e == 'data_change') {
        this.get_user_sys_list();
      }
      if (e == "to_user_info_page") {
        this.menu_select = "uinfo";
        this.$refs.app_user_info.open();
      }
      if (e == "add_admin_btn") {
        for (var i = 0; i < this.rest_menu_list.length; i++) {
          if (this.rest_menu_list[i].key == "admin_login") {
            return;
          }
        }
        //   添加管理后台
        this.rest_menu_list.push({
          name: "管理后台",
          key: "admin_login",
          icon: "iconhoutai",
          path: "/admin_login",
          type: "link",
        });
      }
    },

    // //获取通知数据
    // get_notify_data() {
    //   var that = this;
    //   var obj = {};
    //   http(
    //     "post",
    //     process.env.VUE_APP_HOST + "/staff/notify/notify_list",
    //     obj,
    //     true,
    //     "staff"
    //   )
    //     .then((res) => {
    //       if (res.code == 0) {
    //         that.tonzhi_list = res.data.notify_data;
    //       } else {
    //       }
    //     })
    //     .catch((res) => {
    //       console.log(res, "请求出错");
    //     });
    // },

    // showUnloadMessage(event) {
    //   const message = "你确定要离开这个页面吗？";
    //   event.returnValue = message; // 兼容性设置
    //   return message;
    // },

    // 消息声音变化
    system_setting_change(e) {
      if (e == "update_notify_mp3") {
        // this.get_mp3_notify();
      }
    },

    to_message_page() {
      var currentPath = window.location.href;
      console.log(currentPath);
      open_new_page(currentPath + "?page=message");
    },

    //获取消息数量
    get_msg_count() {
      console.log("循环获取消息");
      var that = this;
      if (!this.msg_count_timer) {
        //获取消息数量
        this.msg_count_timer = setInterval(() => {
          //获取消息数量
          var cookie_msg_count = that.$cookies.get("dx_msg_count");
          try {
            that.msg_count = Number(cookie_msg_count);
          } catch (e1) {
            console.log("消息数量获取失败", e1);
            that.msg_count = 0;
          }

          var current_tsp = new Date().getTime() / 1000;

          // 如果最后通知的条数与新的不一样，再次通知
          if (that.msg_notify_end_count != that.msg_count && that.msg_count > 0) {
            that.pushMessage(
              "大象系统 - 您有" + String(cookie_msg_count) + "条新消息未读，点击查看！",
              "",
              that.to_message_page
            );
            that.msg_notify_end_tsp = current_tsp;
            that.msg_notify_end_count = that.msg_count;
          } else {
            if (
              that.msg_count > 0 &&
              current_tsp - that.msg_notify_end_tsp > that.browser_notify_frequency
            ) {
              that.pushMessage(
                "大象系统 - 您有" + String(cookie_msg_count) + "条新消息未读，点击查看！",
                "",
                that.to_message_page
              );
              that.msg_notify_end_tsp = current_tsp;
              that.msg_notify_end_count = that.msg_count;
            }
          }
        }, 1000);
      }
    },

    //显示消息
    show_message_notify() {
      var that = this;
      setTimeout(function () {
        that.$Notice.config({
          top: 50,
          duration: 2,
        });
        that.$Notice.warning({
          title: "您收到一条新消息，请及时查看！",
          desc: "",
        });
      }, 1000);
    },

    msg_notify() {
      var that = this;
      // 播放音乐
      this.notify_mp3_show = false;
      setTimeout(function () {
        that.notify_mp3_show = true;
      }, 300);
      console.log("菜单开始播放");
      setTimeout(function () {
        var audioElement = document.getElementById("notify_mp3_url");
        audioElement.play().catch((error) => {
          console.log(error);
          console.log("通知声音没有播放");
        });
      }, 500);
    },

    // 关闭通知窗
    // sys_notify_change(e) {
    //   this.notify_mp3_show = true;

    //   //获取消息数量
    //   var that = this;
    //   // that.get_msg_count();

    //   // 轮询获取消息
    //   // if (!this.msg_intervalId) {
    //   //   clearInterval(this.msg_intervalId);

    //   //   //获取消息数量
    //   //   this.msg_intervalId = setInterval(() => {
    //   //     //获取消息数量
    //   //     that.get_msg_count();
    //   //   }, 3000);
    //   // }
    // },

    //确认退出
    quit_button() {
      var that = this;
      get_browser_id();

      this.$Modal.confirm({
        width: 330,
        title: "提示",
        content: "<p>您正在退出登录，退出后需重新登录帐号，确认继续吗？</p>",
        onOk: () => {
          //删除定时器

          clearInterval(that.msg_intervalId);

          that.quit_request();
        },
        onCancel: () => { },
      });
    },

    quit_request() {
      var that = this;
      var obj = {
        dx_browser_id: this.$cookies.get("dx_browser_id", "/", that.cookie_domain),
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/staff/user_index/staff_quit",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$Message.info(res.msg);
            // 清空cookies
            that.del_cookie();
          } else {
            that.$Message.info("请先登录哟~");
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },



    del_cookie() {
      console.log('清除cookies----')
      console.log(this.cookie_domain)
      console.log('清除cookies----')
      console.log('当前域名:', window.location.hostname)
      console.log('设置的domain:', this.cookie_domain)
      var that = this;

      var cookie_list = ['dx_token',
       'dx_private_key', 'dx_public_key',
        'dx_user_info', 'dx_browser_id',
         'dx_msg_count', 'dx_cut_sys_id'
      ]
      for (var j = 0; j < cookie_list.length; j++) {
        that.$cookies.remove(cookie_list[j], {
          path: "/",
          domain: that.cookie_domain,
        });
      }
      for (var j = 0; j < cookie_list.length; j++) {
        that.$cookies.remove(cookie_list[j], {
          path: "/",

        });
      }
      setTimeout(function () {
      }, 1000);
      console.log('删除cookies')
      // }


      setTimeout(function () {
        that.$router.push({
          path: "/",
        });
      }, 1000);
    },

    add_query_params(keystr) {
      console.log(123);

      var query2 = JSON.parse(JSON.stringify(this.$route.query));
      query2.page = keystr;
      console.log(query2);
      this.$router.push({ path: this.$route.path, query: query2 });
    },

    //点击菜单
    click_menu(item) {
      console.log(666666, item);
      // this.zongjie_show = true


      if (item.type == "link") {
        console.log(11111);
        open_new_page(item.path);
        return;
      }

      //退出
      if (item.type == "quit") {
        this.quit_button();
        return;
      }

      this.menu_select = item.key;
      this.add_query_params(item.key);

      if (item.key == "message") {
        console.log('点击消息');
        this.$refs.message_list.refresh();
        return;
      }

      if (item.key == "workbench") {
        this.$refs.workbench.open();
      }

      if (item.key == "study") {
        this.$refs.study.open();
      }


      if (item.key == "uinfo") {
        this.$refs.app_user_info.open();
      }

      if (item.key == "safe") {
        this.$refs.user_safe.open();
      }
      if (item.key == "download") {
        this.$refs.app_download.open();
      }
      if (item.key == "app_download") {
        this.$refs.app_download.open();
      }
      if (item.key == "system_setting") {
        this.$refs.system_setting.open();
      }
    },

    // get_user_data() {
    //   var userinfo = this.$cookies.get("dx_user_info");
    //   if (userinfo != "undefined") {
    //     this.userinfo = userinfo;
    //   }

    //   //   添加管理后台
    //   if (this.userinfo.is_super_admin == 1) {
    //     this.rest_menu_list.push({
    //       name: "管理后台",
    //       key: "admin_login",
    //       icon: "iconhoutai",
    //       path: "/admin_login",
    //       type: "link",
    //     });
    //   }
    // },
  },
};
</script>

<style scoped>
.sys_cut_btn {
  padding: 10px;
  border: 1px solid #ccc;

  border-radius: 5px;
  font-weight: 600;
  background-color: #f0f3ff;
  margin: 10px 20px 10px 10px;

}

.sys_cut_btn_div {
  display: flex;

}

.sys_cut_btn:hover {
  cursor: pointer;
  border: 1px solid #387eff;
}

.sys_cut {
  display: flex;
  align-items: center;
  justify-content: end;
  margin-top: 5px;
}

.cut_sys_span {
  font-size: 12px;
  color: #fff;
}

.sys_btn_cut_title {
  font-weight: 600;
  color: #ffffff
}

.sys_btn_cut:hover {
  cursor: pointer;
}

.sys_btn_cut {
  color: #fff;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  animation: pulse 2s infinite;
  /* animation: colorChange 3s infinite alternate; */

  /* animation: smoothColor 5s infinite alternate ease-in-out; */
}

/* 关键帧动画 - 定义颜色变化序列 */
@keyframes colorChange {
  0% {
    background-color: #ff6b6b;
  }

  25% {
    background-color: #4ecdc4;
  }

  50% {
    background-color: #45b7d1;
  }

  75% {
    background-color: #96ceb4;
  }

  100% {
    background-color: #ffeaa7;
  }
}

@keyframes pulse {

  0%,
  100% {
    background-color: #003ec4;
  }


  50% {
    background-color: #1063fc;
  }





}

/* 
@keyframes smoothColor {
  from {
    background-color: #002ec4;
  }

  to {
    background-color: #d70595;
  }
} */

/* .sys_btn_cut {
  background-color: #0466dd;
  color: #fff;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
} */

.tabs1_class {}

.watermark_div {
  box-sizing: border-box;
  /* 确保内边距不影响尺寸 */
  position: fixed;
  width: 100vw;
  height: 100vh;
  margin: 0;
  /* 重置外边距 */
  padding: 0;
  /* 重置内边距 */
  /* background-color: red; */
  z-index: 99999;
  top: 0;
  left: 0;
  pointer-events: none
}

.zongjie_div {
  height: 50vh;
  position: relative;
  overflow: auto;
}


.text-container {
  /* white-space: pre-line !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  white-space-collapse: preserve;
  line-height: 1.8;
  font-size: 14px;
  color: #333; */
}

.tongzhi_detail {
  padding: 5px 10px 0 5px;
}

.tongzhi_title {
  font-weight: 600;
  font-size: 14px;
}

.tongzhi_time {
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
  font-size: 13px;
  color: #ccc;
}

.tongzhi {
  height: 400px;
  overflow: auto;
}

.dispno {
  display: none;
}

.btn_div {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.msg_count {
  position: absolute;
  right: -4px;
  font-size: 12px;
  border-radius: 10px;
  height: 18px;
  padding: 0 6px;
  line-height: 18px;
  text-align: center;
  background: red;
  border: 1px solid #ff8f8f;
  color: #fff;
  top: -5px;
}

#notify_mp3_url {
  display: none;
}

.page_content {
  display: flex;
  background-color: #ececec;
  /* background: #ccc; */
}

.resetmenu {
  border-top: 1px solid #dddddd;
  padding-top: 20px;
  margin-top: 20px;
}

.menu_btn_span {
  margin-left: 5px;
  font-size: 13px;
}

.menu_btn2:hover {
  color: #0777ff;
  background: #bfd4ef;
  cursor: pointer;
}

.menu_btn {
  position: relative;
  cursor: pointer;
  padding: 5px 10px;
  background: #0466dd;
  color: #fff;
  border-radius: 5px;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  font-size: 15px;
}

.menu_btn2 {
  position: relative;
  padding: 5px 10px;
  color: #666;
  border-radius: 5px;
  display: flex;
  margin-bottom: 10px;
  align-items: center;
  font-size: 15px;
}

.username {
  width: 60px;
  font-weight: 600;
  color: #000;
  overflow: hidden;
}

.userinfo_avatar_div {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  margin-top: 20px;
}

.user_avatar {
  width: 35px;
  height: 35px;
  border: 1px solid #e3e9f0;
  box-shadow: 0 0 2px #d3d5da;
  border-radius: 6px;
  margin-right: 8px;
  margin-left: 5px;
}

.left1 {
  padding: 10px;
  width: 120px;
  border-right: 2px solid #e3e3e3;
  height: 100vh;
  background: #eceef0;
  flex-shrink: 0;
}
</style>
